// const isDevelopment = process.env.DEV

export default {
  authServerEndpoint: process.env.authServerEndpoint || 'http://localhost:8000/', // Should end with a slash
  redirectUrl: process.env.redirectUrl || 'http://one.vue.co.ke:8080',
  clientId: process.env.clientId || '60d9c872dde657da5f2ff37c',
  ClientSecret: process.env.ClientSecret || '',
}
